import { SET_FEATURE_FLAG } from 'constants/ActionTypes';

const InitState = {
  myevRefreshDashboard: false,
  myevRefreshSettings: false,
  myevRefreshBillingInfo: false,
  myevRefreshContactInfo: false,
  myevRefreshDuplicatePopup: false,
  myevRefreshFinalizeSubstitutions: false,
  enableGeomniEsxAddonLogic: false,
  subscriptionDashboard: false,
  // #genai Phase 2 multi-payment-methods gate. Real value is delivered by the host portal via
  // SET_FEATURE_FLAG (sourced from LaunchDarkly); default OFF so nothing Phase 2 renders until
  // the host explicitly turns it on.
  enableMultiPaymentMethods: false,
  // #genai Order History Sitemap Approval button. Host portal delivers via SET_FEATURE_FLAG
  // (LD MYEV_SITEMAP_AUTOMATION → camelCase myevSitemapAutomation); default OFF.
  myevSitemapAutomation: false,
};

export default (state = InitState, action = {}) => {
  switch (action.type) {
    case SET_FEATURE_FLAG: return { ...action.featureFlag };
    default: return state;
  }
};
